import { render, staticRenderFns } from "./stockView.vue?vue&type=template&id=1dc8a8d0&scoped=true&"
import script from "./stockView.vue?vue&type=script&lang=js&"
export * from "./stockView.vue?vue&type=script&lang=js&"
import style0 from "./stockView.vue?vue&type=style&index=0&id=1dc8a8d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc8a8d0",
  null
  
)

export default component.exports